<template>
  <div>
    <b-container fluid>
      <div class="row justify-content-between">
        <div class="col-12">
          <div class="playnow-menu">
            <!-- <b-btn
              @click="changePlaySection('competitive', $event)"
              block
              class="section-link active"
            >Ranked</b-btn>
            <b-btn @click="changePlaySection('training', $event)" block class="section-link">Treino</b-btn>
            <b-btn @click="changePlaySection('lobbies', $event)" block class="section-link">Lobbies</b-btn>-->
          </div>
        </div>
      </div>

      <!--<div class="col-8" ref="playnow-content">
          <div class="playnow-content active" ref="playnow-content-competitive">
            <h3 class="section-title">Jogue com outros jogadores e upe seu Level</h3>

            <div class="anticheater-container">
              <div class="row">
                <div class="col-2">
                  <a href="steam://run/282660">
                    <img src="https://www.easy.ac/static/img/logo-easy.png" alt>
                  </a>
                </div>
                <div class="col-7">
                  <h6>Anti-cheat obrigatório</h6>
                  <p>Você precisa estar com o anti-cheat instalado e aberto para jogar</p>
                </div>
                <div class="col-3">
                  <a href="steam://run/282660">
                    <img src="https://www.easy.ac/static/img/logo-easy.png" alt>
                  </a>
                </div>
              </div>
            </div>

            <div class="content-area">
              <div class="maps">
                <div :class="`${map} map`" v-for="map in maps" :key="map">
                  <p class="map-name" v-b-tooltip.hover title="será vetado dentro do servidor">
                    <i class="fas fa-check"></i>
                    {{map}}
                  </p>
                </div>
              </div>
              <p class="map-info">todos os mapas selecionados</p>

              <div v-if="clubs.length > 0" class="clubs-container">
                <b-form-group
                  description
                  label="Clube"
                  v-b-tooltip.hover
                  title="você pode buscar partida apenas com membros de seu clube"
                >
                  <b-form-select v-model="club_id" class="mb-3">
                    <option value>jogar com todos os jogadores do QUEOTA.club</option>
                    <option v-for="club in clubs" :key="club.id" :value="club.id">{{ club.name }}</option>
                  </b-form-select>
                </b-form-group>
              </div>

              <div class="checklist">
                <b-form-checkbox
                  id="checkbox1"
                  v-model="check1"
                  value="true"
                  unchecked-value
                >Prometo que irei jogar a partida até o final e respeitar a todos</b-form-checkbox>
                <b-form-checkbox id="checkbox2" v-model="check2" value="true" unchecked-value>
                  Já abri o
                  <a
                    href="steam://run/282660"
                    target="_blank"
                    style="text-decoration:underline"
                  >anticheater do QUEOTA.club (easy.ac)</a>
                </b-form-checkbox>
                <div class="search-button" v-if="check1 && check2">
                  <b-button
                    v-on:click.stop.prevent="searchMatch"
                    variant="success"
                    size="lg"
                  >Procurar partida</b-button>
                </div>
              </div>
            </div>
          </div>
          <div class="playnow-content" ref="playnow-content-training">training</div>
          <div class="playnow-content" ref="playnow-content-lobbies">lobbies</div>
        </div>
      </div>
       <b-row>
            <b-col>
              <a href="/forfun" @click.stop.prevent="hideModal('/forfun')" class="gamemode">
                <h2>Forfun</h2>
                <p>DM para aquecer sua mira</p>
              </a>
            </b-col>
            <b-col>
              <a href="/ranked" @click.stop.prevent="hideModal('/ranked')" class="gamemode">
                <h2>Ranked </h2>
                <p>encontramos outros jogadores e colocamos vocês na mesma lobby</p>
              </a>
            </b-col>
            <b-col>
              <a href="/rooms" @click.stop.prevent="hideModal('/rooms')" class="gamemode">
                <h2>Lobbies</h2>
                <p>cria uma sala com seus amigos</p>
              </a>
            </b-col>
      </b-row>-->
    </b-container>
  </div>
</template>

<script>
export default {
  name: "PlayNow",
  computed: {
  },
  data: function() {
    return {
      closed: true,
      subscription: Object,
      maps: [
        "de_inferno",
        "de_dust2",
        "de_mirage",
        "de_cache",
        "de_overpass",
        "de_train",
        "de_nuke"
      ],
      check1: false,
      check2: false,
      state: "",
      timeLeftToReady: 0,
      hasAccepted: false,
      playersSearching: 0,
      demoInterval: Object,
      leftInterval: Object,
      club_id: "",
      clubs: []
    };
  },
  methods: {
    openModal() {
      this.$refs.playNowModal.show();
    },

    changePlaySection(sectionName, event) {
      event.target.parentNode
        .querySelector(".active")
        .classList.remove("active");
      event.target.classList.add("active");

      this.$refs[`playnow-content`]
        .querySelector(".active")
        .classList.remove("active");
      this.$refs[`playnow-content-${sectionName}`].classList.add("active");
    }
  }
};
</script>

